export default __webpack_public_path__ + "static/media/htb_mb.ced5c7f4.png";